import { useState } from "react";
import axios from "axios";
import { MailCheck, Loader2 } from "lucide-react";
import { API_URL } from "@/lib/links";

export const TestEmailButton = ({ headers }) => {
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState(null);

  const run = async () => {
    setBusy(true);
    setMsg(null);
    try {
      const { data } = await axios.post(`${API_URL}/admin/test-email`, {}, { headers });
      setMsg({ ok: true, text: `Test email sent to ${data.sent_to}` });
    } catch (err) {
      setMsg({ ok: false, text: err.response?.data?.detail || "Could not send" });
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex flex-col items-end gap-1.5">
      <button type="button" onClick={run} disabled={busy} className="btn btn-secondary !px-4 !py-2 text-sm" data-testid="admin-test-email-button">
        {busy ? <Loader2 size={14} className="animate-spin" /> : <MailCheck size={14} />} Send test email
      </button>
      {msg && <p className={`text-xs ${msg.ok ? "text-emerald-300" : "text-red-400"}`} data-testid="admin-test-email-result">{msg.text}</p>}
    </div>
  );
};
